<template>
  <button @click="exportData" class="btn btn-sm btn-primary mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/client-chatbot/', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let source;
          if (!item.client.utm_source) {
            source = "Tự nhiên";
          } else if (item.client.utm_source && item.client.utm_source === 'sales') {
            source = "NVKD tự tìm"
          } else {
            source = "Marketing";
          }

          let status;
          if (!item.confirmTime && !item.cancelTime) {
            status = this.$t('waiting');
          } else if (item.confirmTime) {
            status = this.$t('confirmed');
          } else {
            status = this.$t('canceled');
          }

          let row = {
            clientName: item.client && item.client.companyName ? item.client.companyName : '',
            domain: item.client && item.client.domain ? item.client.domain : '',
            source: source,
            sales: item.sales ? item.sales.name : '',
            type: this.$t(item.type),
            limit: item.limit ? item.limit : 0,
            monthCount: item.monthCount ? item.monthCount : 0,
            expireTime: moment(item.confirmTime).format('DD/MM/YYYY HH:mm:ss'),
            total: item.total ? item.total : 0,
            status: status,
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            confirmTime: item.confirmTime ? moment(item.confirmTime).format('DD/MM/YYYY HH:mm:ss') : '',
            cancelTime: item.cancelTime ? moment(item.cancelTime).format('DD/MM/YYYY HH:mm:ss') : '',
            note: item.note ? item.note : '',
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'client-chatbot.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('clientName'), key: 'clientName', width: 15},
        {header: this.$t('domain'), key: 'domain', width: 15},
        {header: this.$t('source'), key: 'source', width: 15},
        {header: this.$t('sales'), key: 'sales', width: 15},
        {header: this.$t('type'), key: 'type', width: 15},
        {header: this.$t('userLimit'), key: 'limit', width: 15},
        {header: this.$t('monthCount'), key: 'monthCount', width: 15},
        {header: this.$t('expireTime'), key: 'expireTime', width: 20},
        {header: this.$t('total'), key: 'total', width: 15},
        {header: this.$t('status'), key: 'status', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 20},
        {header: this.$t('confirmTime'), key: 'confirmTime', width: 20},
        {header: this.$t('cancelTime'), key: 'cancelTime', width: 15},
        {header: this.$t('note'), key: 'note', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      vi: {
        waiting: 'Đợi xác nhận',
        confirmed: 'Đã xác nhận',
        canceled: 'Đã huỷ',
        client: 'Khách hàng',
        type: 'Loại',
        userLimit: 'Số nhân viên AI',
        monthCount: 'Số tháng',
        expireTime: 'Thời gian hết hạn',
        total: 'Tổng',
        createTime: 'Thời gian tạo',
        confirmTime: 'Thời gian xác nhận',
        cancelTime: 'Thời gian huỷ',
        note: 'Ghi chú',
        exportingData: 'Đang xuất dữ liệu',
        exportNotice: 'Dữ liệu đang được tải xuống, vui lòng đợi xong giây lát...',
        new: 'Mua mới',
        extend: 'Gia hạn',
        user: 'Mua thêm nhân viên AI',
        clientName: 'Tên khách hàng/công ty',
        sales: 'Sales',
        account: 'Chăm sóc',
        source: "Nguồn",
        companySource: "Nguồn công ty",
        selfFindingSource: "Nguồn tự tìm",
        trial: "Dùng thử",
      },
      en: {
        waiting: 'Đợi xác nhận',
        confirmed: 'Đã xác nhận',
        canceled: 'Đã huỷ',
        client: 'Client',
        type: 'Type',
        userLimit: 'Number of AI agents',
        monthCount: 'Number of month',
        expireTime: 'Expire time',
        total: 'Total',
        createTime: 'Create time',
        confirmTime: 'Confirm time',
        cancelTime: 'Cancel time',
        note: 'Note',
        exportingData: 'Exporting data',
        exportNotice: 'Data is being exported. Please wait for a few moment...',
        new: 'New',
        extend: 'Extend',
        user: 'Buy AI agent',
        clientName: 'Client name/company name',
        sales: 'Sales',
        source: "Source",
        account: 'Account',
        companySource: "Company source",
        selfFindingSource: "Self finding source",
        trial: "Trial",
      },
    }
  }
}
</script>